export const GET_TASKS_FULFILLED = 'tasks/getTasks/fulfilled'
export const GET_TASKS_PENDING = 'tasks/getTasks/pedning'
export const GET_TASKS_REJECTED = 'tasks/getTasks/rejected'